import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from '../service/analytics.service';

@Directive({
  selector: '[trackView]',
  standalone: false
})
export class TrackViewDirective implements OnInit, OnDestroy {
  @Input('trackView') productName!: string;
  private observer!: IntersectionObserver;

  constructor(private el: ElementRef, private analytics: AnalyticsService) {}

  ngOnInit() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Trigger the event when the element becomes visible
            this.analytics.trackUserInteraction(
              `view_product_${this.productName}`,
              `Viewed ${this.productName}`,
              'guest'
            );
            // Stop observing after first view
            this.observer.unobserve(this.el.nativeElement);
          }
        });
      },
      { threshold: 0.5 } // Adjust: 0.5 means 50% of element must be visible
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
